<template>
  <div class="block-img" v-if="block.file">
    <figure :style="'padding-top:'+block.file.ratio+'%'">
      <img class="toLoad"  v-if="block.file.type != 'gif'"
        v-lazy="block.file.url" 
        :srcset="block.file.srcset"
        sizes="100vw, (min-width: 768px) 50vw, (min-width: 1040px) 100vw"
        @load="displayImage($event)"/>
      <img class="toLoad" v-else
        v-lazy="block.file.url" 
        @load="displayImage($event)"/>
      </figure>
  </div>
</template>

<script>

import scrollBehavior  from '@/mixins/scrollBehavior.js'
import loaderHandler  from '@/mixins/loaderHandler.js'

export default {
  mixins: [scrollBehavior, loaderHandler],
	props: ['block','currentLang'],
	methods:{
		displayImage(e){
			let el = e.target;
			setTimeout(
				function(){ el.classList = 'loaded';
			}, 300);
		}
	},
}
</script>

<style lang="scss">
  .block-img{
    figure{
      height: 0;
      position:relative;
      img{
        position:absolute;
        top:0;
        left:0;
        width:100%;
        height: auto;
      }
    }
  }
  .bloc--regular .block-img{
    max-width: 850px;
    margin: auto;
  }
</style>